import { createContext, useContext } from 'react';

export const InvoiceContext = createContext(null);

export function useInvoiceContext() {
  const ctx = useContext(InvoiceContext);
  if (!ctx) throw new Error('useInvoiceContext muss innerhalb von InvoiceProvider genutzt werden');
  return ctx;
}